import React, { useState, useEffect } from "react";
import { HashLink as Link } from "react-router-hash-link";

const Nav = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Empêche le scroll en arrière-plan quand le menu est ouvert
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  return (
    <section className="nav-section" id="nav">
      <Link to="/#">
        <img
          className="logo"
          src={require("../../assets/img/logo.ico")}
          alt="logo"
          style={{ width: "125px" }}
        />
      </Link>

      <button
        className={`hamburger hamburger--collapse mobile ${isOpen ? "is-active" : ""}`}
        type="button"
        onClick={toggleMenu}
        aria-controls="basic-navbar-nav"
        aria-expanded={isOpen}
        aria-label="Toggle navigation"
      >
        <span className="hamburger-box">
          <span className="hamburger-inner"></span>
        </span>
      </button>
      
      {/* L'overlay est toujours présent, contrôlé via la classe "visible" */}
      <div className={`menu-overlay ${isOpen ? "visible" : ""}`}>
        <Link className="nav-links" to="/#about" onClick={toggleMenu}>
          À propos
        </Link>
        <Link className="nav-links" to="/#services" onClick={toggleMenu}>
          Nos services
        </Link>
        <Link className="nav-links" to="/#team" onClick={toggleMenu}>
          Notre équipe
        </Link>
        <Link className="nav-links" to="/#contact" onClick={toggleMenu}>
          Contact
        </Link>
      </div>
    </section>
  );
};

export default Nav;